import utils from '@/_modules/utils';
import {gsap, Quart} from 'gsap/all';

class _eventSort {
  //constructor() {}

  once() {
    this.currentSort = '';
    this.isSort = false;
    this.max = 6;

    // 一覧
    this.el = document.getElementById('sort-list');

    if (this.el) {
      // セミナーごとのタグでソート
      this.el.querySelectorAll(':scope > li').forEach((el, i) => {
        el.querySelectorAll('.c-icon-cate').forEach((tag, j) => {
          tag.addEventListener('click', this.linkSort.bind(this, tag.hash.replace('#', '')));
        });
      });

      // ソート後に使うノードを用意
      this.cloneData = this.el.cloneNode(true);
      this.cloneData.querySelectorAll(':scope > li').forEach((el, i) => {
        el.classList.remove('sort-box');
        el.style.visibility = 'hidden';
      });

      // 初期は最大6件
      this.list = this.el.querySelectorAll(':scope > li');
      for (let i = 0; i < this.max; i++) {
        if (!this.list[i]) break;
        this.list[i].classList.remove('sort-box');
      }

      // セレクトボックス
      this.select = document.getElementById('select-sort');
      this.select.addEventListener('change', this.changeSort.bind(this));
    }

    // Nextボタン
    this.btnAdd = document.getElementById('btn-add-list');
    this.bindAdd = null;
    if (this.btnAdd) {
      this.bindAdd = this.addList.bind(this);
      this.btnAdd.addEventListener('click', this.bindAdd);
    }
  }

  init() {

  }

  linkSort(val, e) {
    e.preventDefault();
    
    // 続きは表示してしまう
    this.addList();

    // セレクトボックスを選択する
    for (let i = 0; i < this.select.options.length; i++) {
      if (this.select.options[i].value === val) {
        this.select.options[i].selected = true;
        break;
      }
    }

    this.currentSort = 'sort-' + val;

    // 非表示実行
    gsap.to(this.el.querySelectorAll(':scope > li'), {
      duration: 0.5,
      autoAlpha: 0,
      display: 'none',
      ease: Quart.easeOut,
      stagger: 0.01,
      onComplete: this.hideComp.bind(this),
    });
  }

  changeSort(e) {
    console.log('あいうえおあいうえお');
    // 続きは表示してしまう
    this.addList();

    // 選択されたソート項目
    const sortNum = this.select.selectedIndex;
    if (sortNum > 0) {
      this.currentSort = 'sort-' + this.select.options[sortNum].value;
    } else {
      this.currentSort = null;
    }

    // 非表示実行
    gsap.to(this.el.querySelectorAll(':scope > li'), {
      duration: 0.5,
      autoAlpha: 0,
      display: 'none',
      ease: Quart.easeOut,
      stagger: 0.01,
      onComplete: this.hideComp.bind(this),
    });
  }

  hideComp() {
    // 削除
    this.el.querySelectorAll(':scope > li').forEach((el, i) => {
      el.remove();
    });
  
    // 追加
    this.cloneData.querySelectorAll(':scope > li').forEach((el, i) => {
      if (!this.currentSort || el.classList.contains(this.currentSort)) {
        this.el.appendChild(el.cloneNode(true));
      }
    });

    requestAnimationFrame(this.show.bind(this));
  }

  show() {
    // 表示実行
    gsap.fromTo(this.el.querySelectorAll(':scope > li'), {
      visibility: 'visible',
      autoAlpha: 0,
    }, {
      duration: 0.5,
      autoAlpha: 1,
      ease: Quart.easeOut,
      stagger: 0.03,
      onComplete: this.showComp.bind(this),
    });
  }

  showComp() {
    //console.log('showComp');

    // セミナーごとのタグでソート
    this.el.querySelectorAll(':scope > li').forEach((el, i) => {
      el.querySelectorAll('.c-icon-cate').forEach((tag, j) => {
        tag.addEventListener('click', this.linkSort.bind(this, tag.hash.replace('#', '')));
      });
    });
  }

  addList() {
    if (this.max >= this.list.length) return;

    // 続きを表示する
    this.max = this.list.length;
    this.list.forEach((el) => {
      el.classList.remove('sort-box');
    });

    gsap.to(this.btnAdd, {
      duration: 0.5,
      autoAlpha: 0,
      display: 'none',
      ease: Quart.easeOut,
      onComplete: this.addComp.bind(this),
    });
  }

  addComp() {
    this.btnAdd.removeEventListener('click', this.bindAdd);
    delete this.bindAdd;
    delete this.btnAdd;
  }
}

const eventSort = new _eventSort();

export default eventSort;